import i18n from "../../resources/I18n";
import "./clickToCall.css";
import { obtenirURLClickToCall } from "../../util/ClickToCall";
import * as TYPE_PROJET from "../../constants/typeprojet";
import { useCybermetrieAMCContext } from "../utils/CybermetrieAMCContext";
import { CybermetriesAMC } from "../../util/CybermetrieAMC";

interface IClickToCall {
  noDemande?: string;
  transit?: string;
  id?: string;
}

export default function ClickToCall(props: Readonly<IClickToCall>) {
  let cybermetrieParams = useCybermetrieAMCContext();

  return (
    <div id={props.id} data-testid="container-click-to-call">
      <h2 id="titre-click-to-call">{i18n.t("amc:click-to-call-titre")}</h2>{" "}
      <hr className="ligne-noir-ctc-amc" data-testid="ligne-noire" />
      <div className="container-ctc">
        <div className="container-demandez-appel">
          <div className="texte-demandez-appel-amc">
            <p className="click-to-call-texte" data-testid="click-to-call-texte">
              {i18n.t("amc:click-to-call-texte")}
            </p>
          </div>
          <dsd-link-action
            onClick={() => CybermetriesAMC.EnvoiePlanifierAppelAMC(cybermetrieParams)}
            data-testid="dsd-link-action"
            type="external"
          >
            <a
              data-testid="clic-appeler-conseiller-amc"
              href={obtenirURLClickToCall(
                props.noDemande,
                props.transit,
                "Marge credit",
                "Fin_Marge_Cred",
                TYPE_PROJET.AMC
              )}
              target="_blank"
              rel="noreferrer"
            >
              {i18n.t("amc:click-to-call-texte-lien")}
              <span className="dsd-sr-only">&nbsp;{i18n.t("sr-only-ouverture-nouvel-onglet")}</span>
            </a>
          </dsd-link-action>
        </div>
      </div>
    </div>
  );
}
